import $ from 'jquery'
import '../../static/fancybox/jquery.fancybox.pack'
import '!vue-style!css!../../static/fancybox/jquery.fancybox.css'

export default {
  install (Vue) {
    Vue.directive('fancybox', {
      params: ['selector'],
      update (val) {
        $(this.params.selector).fancybox()
      },
      paramsWatchers: {
        selector (val) {
          this.update()
        }
      }
    })
  }
}



/** WEBPACK FOOTER **
 ** ./src/directives/v-fancybox.js
 **/